import {BaseEntity} from "../common/base-entity";
import { CirfClientInfo } from './cirf-client-info';
import {CirfMortgage, MortgageTypeValue} from './cirf-mortgage';
import { CirfInsuranceDetail } from './cirf-insurance-detail';
import { CirfMatterContactInfo } from './cirf-matter-contact-info';
import {ProvinceCode} from "./cirf";
import {NavigationSection} from "./cirf-navigation";
import {CIRF_NAME_KEYS} from "../shared/constants";

/**
 * This class is for capturing any matter level information in cirf request and other aggregated entities
 */
export class CirfMatterData extends BaseEntity {
    matterNotes: string;
    insuranceNotes: string;
    mortgageNotes: string;
    existingMortgageNotes: string;
    clientNotes: string;
    cirfClients : CirfClientInfo[] = [];
    mortgages: CirfMortgage[] = [];
    fireInsuranceDetail: CirfInsuranceDetail;
    matterContactInfo: CirfMatterContactInfo;
    matterType: string;
    customMatterTypeCode: string;
    customMatterTypeDesc: string;
    firmName: string;
    propertyAddressText: string;
    legalDescriptionSummary: string;
    closingDate: string;
    provinceCode: ProvinceCode;
    selectedNavSection: NavigationSection;
    accessNavSections: NavigationSection[];

    constructor(cirfMatterData?: CirfMatterData) {
        super(cirfMatterData);
        if(cirfMatterData) {
            this.cirfClients = [];
            if(Array.isArray(cirfMatterData.cirfClients)) {
                for(let cc of cirfMatterData.cirfClients) {
                    this.cirfClients.push(new CirfClientInfo(cc));
                }
            }
            this.mortgages = [];
            if(Array.isArray(cirfMatterData.mortgages)) {
                for(let cc of cirfMatterData.mortgages) {
                    this.mortgages.push(new CirfMortgage(cc));
                }
            }
            if(cirfMatterData.fireInsuranceDetail) {
                this.fireInsuranceDetail = new CirfInsuranceDetail(cirfMatterData.fireInsuranceDetail);
            }
            if(cirfMatterData.matterContactInfo) {
                this.matterContactInfo = new CirfMatterContactInfo(cirfMatterData.matterContactInfo);
            }
            if(cirfMatterData.selectedNavSection){
                this.selectedNavSection = new NavigationSection(cirfMatterData.selectedNavSection);
            }

        }
        if(!this.provinceCode){
            this.provinceCode = 'ON';
        }
        if(!this.matterNotes){
            this.matterNotes = '';
        }
        if(!this.insuranceNotes){
            this.insuranceNotes = '';
        }
        if(!this.mortgageNotes){
            this.mortgageNotes = '';
        }
        if(!this.existingMortgageNotes){
            this.existingMortgageNotes = '';
        }
        if(!this.clientNotes){
            this.clientNotes = '';
        }
    }

    get newMortgages() : CirfMortgage[]{
        return this.mortgages.filter(mtg=>mtg.mortgageType == MortgageTypeValue.New);
    }

    get existingMortgage() : CirfMortgage[]{
        return this.mortgages.filter(mtg=>mtg.mortgageType == MortgageTypeValue.Existing);
    }

    isCustomMatter(): boolean {
        return (!!this.customMatterTypeCode)
    }

    removeMortgageAccessNavSection(isNewMortgage: boolean, mortgageIndex: number){
        if(mortgageIndex > -1){
            let navSectionIndex = this.accessNavSections.findIndex(item=>{
                return isNewMortgage ? item.newMortgageIndex == mortgageIndex : item.existingMortgageIndex == mortgageIndex
            });
            if(navSectionIndex > -1){
                this.accessNavSections.splice(navSectionIndex, 1);
            }
        }
    }

    removeClientAccessNavSections(clientIndex: number){
        if(clientIndex > -1){
            this.accessNavSections = this.accessNavSections.filter(item=>item.clientIndex != clientIndex);
        }
    }

    findExistingAccessNavSection(resetSelection: NavigationSection): boolean{
        let found: boolean;
        if(!Array.isArray(this.accessNavSections)){
            this.accessNavSections = [];
        }
        if(this.accessNavSections && this.accessNavSections.length > 0) {
            found = !!this.accessNavSections.find(item=>{
                if(item.newMortgageIndex > -1 && resetSelection.newMortgageIndex > -1 && item.newMortgageIndex == resetSelection.newMortgageIndex){
                    return item;
                }
                if(item.existingMortgageIndex > -1 && resetSelection.existingMortgageIndex > -1 && item.existingMortgageIndex == resetSelection.existingMortgageIndex){
                    return item;
                }
                if(resetSelection.sectionKey ){
                    if(resetSelection.sectionKey ==  CIRF_NAME_KEYS.personalDetails.key
                        || resetSelection.sectionKey ==  CIRF_NAME_KEYS.contactDetails.key
                        || resetSelection.sectionKey ==  CIRF_NAME_KEYS.idVerification1.key
                        || resetSelection.sectionKey ==  CIRF_NAME_KEYS.idVerification2.key){
                        if(item.clientIndex == resetSelection.clientIndex && item.sectionKey == resetSelection.sectionKey){
                            return item;
                        }
                    }else {
                        if(item.sectionKey == resetSelection.sectionKey){
                            return item;
                        }
                    }
                }

            });
        }
        return found;
    }
}
